export const defaultWidth = 1080;
